<div class="stellar-wrapper" #stellar 
  [class.disabled]="disabled"
  [class.is-mobile]="isMobile"
  [ngStyle]="!isMobile && {'transform': 'scale(' + scale + ')', 'margin' : verticalIntend }"> 
  <div class="stellar-wrapper__center">
    <div class="stellar-wrapper__center__no-slider"></div>
  </div>

  <div class="stellar" id="soft-skills-stellar" [class.is-mobile]="isMobile">
    <ng-container *ngFor="let skill of skillsForm.controls; let i = index;">
      <div class="stellar__ray" [class.loading]="loading">
        <!-- <div style="margin-left: 60px;">{{ skill.get('score').value }}</div> -->
        <div class="stellar__skill-title-area">
          <div class="stellar__skill-title tooltip">
            
            {{ allSkills[i].name | translate }} <i class="app-ico-mask app-ico-mask__info"></i>
          </div>
          <div class="tooltiptext">{{ allSkills[i].tooltip | translate }}</div>
        </div>
        <div class="stellar__axis"></div>
      <div class="stellar__triangle">
          <!-- <span [ngStyle]="{ 'border-width' : '15px 0 14px ' 
            + (skill.get('score').value > 180
              ? 180
              : skill.get('score').value < 40 
                ? 50 
                : (skill.get('score').value + 15)) + 'px' }">
          </span> -->
          <span [ngStyle]="{ 'border-width' : '15px 0 14px ' 
            + (skill.get('score').value >= 100
              ? 180
              : skill.get('score').value <= 35 
                ? 70
                : (skill.get('score').value * 2)) + 'px' }">
          </span>
        </div>
        <!-- <input type="range" min="1" max="190" 
          [ngStyle]="{'--bg-color': skill.get('color').value }"
          [formControl]="getSkillValueByIndex(i)"
          (input)="valueChanged($event, skill.get('name').value)"> -->
        <input type="range" min="1" max="100" 
          [ngStyle]="{'--bg-color': skill.get('color').value }"
          [formControl]="getSkillValueByIndex(i)"
          (input)="valueChanged($event, skill.get('name').value)">
      </div>
    </ng-container>
  </div>
</div>
